import { ReactComponent as AdminDashboardLogo } from '@percent/admin-dashboard/common/assets/images/admin_dashboard_logo.svg'
import { ReactComponent as SandboxIcon } from '@percent/admin-dashboard/common/assets/images/sandbox-icon.svg'
import { environment } from '@percent/admin-dashboard/config'
import { environments } from '@percent/admin-dashboard/constants/environments'
import style from './AdminLogo.module.scss'

const MARK_SIZE = 40

// The wordmark is drawn as text rather than taken from the svg so it keeps its size when the mark is scaled down.
export function AdminLogo({ isMark = false }: { isMark?: boolean }) {
  const isSandbox = environment === environments.SANDBOX
  const Logo = isSandbox ? SandboxIcon : AdminDashboardLogo
  const mark = <Logo viewBox={`0 0 ${MARK_SIZE} ${MARK_SIZE}`} width={MARK_SIZE} height={MARK_SIZE} />

  if (isMark) {
    return mark
  }

  return (
    <span className={style.logo}>
      {mark}
      <span className={style.wordmark}>{isSandbox ? 'Sandbox' : 'Admin Dashboard'}</span>
    </span>
  )
}
